module.exports = "/_next/static/images/228c2ebe9e8034252c2e09c98e202b79-NoManagementFee.png";